export const ALL_HIDE_POST_NOTIFY_ANNOUNCEMENTS = 'all-hide-post-notify-announcements';
export const RESY_WEB_DEPRECATE_EMAIL_PASSWORD_LOGIN = 'resy_web-deprecate-email-password-login';
export const RESY_WEB_ENABLE_2025_CODE_FREEZE_BUG_175 = 'resy_web-enable-2025_code_freeze_bug_175';
export const RESY_WEB_ENABLE_2025_CODE_FREEZE_BUG_174 = 'resy_web-enable-2025_code_freeze_bug_174';
export const RESY_WEB_ENABLE_LOGIN_OPTIMIZATION_CON_15951_EMAIL_CODE = 'resy_web-enable-login_optimization-con_15951-email_code_an_7ffs0';
export const RESY_WEB_ENABLE_NOMA_GATING = 'resy_web-enable-noma_gating';
export const RESY_WEB_ENABLE_WIDGET_UPDATES_IMPACTING_JCE = 'resy_web-enable-widget_updates_impacting_jce';
export const RESY_WEB_ENABLE_WIDGET_MENU_UPDATES = 'resy_web-enable-widget_menu_updates';
export const CONSUMER_RESY_CREDIT_DISCLAIMER_BANNER = 'consumer-resy-credit-disclaimer-banner';
export const IS_JCE_BRIDGE_ENABLED = 'is_jce_bridge_enabled';
export const IS_JCE_RESERVATION_NOTIFY_ENABLED = 'is_jce_reservation_notify_enabled';
export const ADS_WEB_GEO_ENABLED_COUNTRY = 'ads_web_geo_enabled_country';
export const ADS_WEB_PLACEMENT_HOMEPAGE_ENABLED = 'ads_web_placement_homepage_enabled';
export const ADS_WEB_PLACEMENT_USER_MENU_ENABLED = 'ads_web_placement_user_menu_enabled';
export const RESY_WEB_ENABLE_CUISINE_AGGREGATION_FILTER = 'resy_web-enable-cuisine_aggregation_filter';
export const JCE_INTEGRATION_WINERY = 'jce_integration_winery';
export const RESY_CREDIT_TEMP_COPY = 'resy_credit_temp_copy';
export const RESY__DISCOVERY_COLLECTIONS = 'resy_discovery_collections';
export const CLASSIFY_INTENT_SIGNALS = 'classify_intent_signals';
